import React from 'react';
import { Button, Grid, Heading, Modal, ModalCloser, ModalContent, ModalFooter, Notice, Separator, Text } from '@teliaee/design-system';
import useStores from '../stores/UseStores';

interface PasskeyDeleteConfirmationModalProps {
  onConfirm: () => void;
}

const PasskeyDeleteConfirmationModal = (props: PasskeyDeleteConfirmationModalProps): React.JSX.Element => {
  const { onConfirm } = props;
  const {
    translateStore: { translate },
  } = useStores();
  return (
    <Modal size="6-col">
      <ModalContent>
        <Notice direction="vertical" type="error">
          <Heading className="h3" element="h1">
            {translate('account.passkey.modal.title')}
          </Heading>
          <Separator color="invisible" spacing="xsmall" />
          <Text className="text-left">{translate('account.passkey.modal.description')}</Text>
        </Notice>
      </ModalContent>
      <ModalFooter>
        <Grid align={['between-xs']}>
          <ModalCloser>
            <Button iconLeft="#arrow-left" text={translate('account.passkey.modal.back')} link />
          </ModalCloser>
          <ModalCloser>
            <Button iconLeft="#trashcan-empty" type="withdrawal" text={translate('account.passkey.modal.confirm')} onClick={onConfirm} />
          </ModalCloser>
        </Grid>
      </ModalFooter>
    </Modal>
  );
};

export default PasskeyDeleteConfirmationModal;
